/**
 * Opciones de paginación compartidas para react-data-table-component.
 *
 * - Textos en español (la librería los trae en inglés por defecto).
 * - «Ver todos» (filas por página = total) solo se ofrece cuando el total de
 *   filas es <= MAX_FILAS_VER_TODOS: la librería no virtualiza, así que
 *   montar miles de filas congela el navegador.
 * - No usar en tablas con `paginationServer` (el total lo conoce el servidor).
 */

export const MAX_FILAS_VER_TODOS = 500

export const FILAS_POR_PAGINA_ESTANDAR = [10, 15, 20, 25, 30]

export const TEXTO_FILAS_POR_PAGINA = "Filas por página"
export const TEXTO_SEPARADOR_RANGO = "de"
export const TEXTO_VER_TODOS = "Ver todos"

/** Textos en español comunes (sin la opción «Ver todos»). */
export const textosPaginacion = {
  rowsPerPageText: TEXTO_FILAS_POR_PAGINA,
  rangeSeparatorText: TEXTO_SEPARADOR_RANGO,
}

/**
 * ¿Corresponde ofrecer «Ver todos» para este total de filas?
 * No se ofrece si es redundante: total <= 10 (mínimo de las opciones) o total
 * igual a una opción estándar (10/15/20/25/30), que ya la cubre.
 */
export const puedeVerTodos = total =>
  Number.isFinite(total) &&
  total > Math.min(...FILAS_POR_PAGINA_ESTANDAR) &&
  total <= MAX_FILAS_VER_TODOS &&
  !FILAS_POR_PAGINA_ESTANDAR.includes(total)

/**
 * Props de paginación para una tabla de cliente, en función del total de filas.
 * Uso: <DataTable data={x} pagination {...opcionesPaginacion(x.length)} />
 * No cambia `paginationPerPage` (el valor por defecto lo define cada tabla).
 */
export const opcionesPaginacion = total => {
  const verTodos = puedeVerTodos(total)
  return {
    paginationRowsPerPageOptions: FILAS_POR_PAGINA_ESTANDAR,
    paginationComponentOptions: {
      ...textosPaginacion,
      selectAllRowsItem: verTodos,
      selectAllRowsItemText: TEXTO_VER_TODOS,
    },
  }
}
